// extracted by mini-css-extract-plugin
module.exports = {"boldheader":"Home_boldheader__zLsra","banner2":"Home_banner2__JIV_P","border":"Home_border__1jJyL","banner3":"Home_banner3__1wMde"};